// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_list-category li{margin:12px 0;font-weight:normal;font-size:14px}.home-page-categories .card{min-height:78px}`, "",{"version":3,"sources":["webpack://./resources/app/modules/public/HomePage/index.scss"],"names":[],"mappings":"AAAA,uBACE,aAAA,CACA,kBAAA,CACA,cAAA,CAEF,4BACE,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
